import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import GenPdf from "../../GenPdf";
import { fetchPgcByDoss } from "../../../redux/actions/pgcActions";
import { deletePgc, genPgcPDF, getPgcFile } from "../Utils";
import { changeTitleName, changePdfFileName, changeIndication } from "../../../redux/actions/emailAction";
import { Button } from "@material-ui/core";
import { PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, Delete as DeleteIcon } from "@material-ui/icons";
import Header from "../../Header/Header";
import DocMenu from "../../DocMenu";
import NumDossPGC from "../../NumDossPGC";
import YesNoDialog from "../../YesNoDialog";
import "../../../Styles/PGC/Validation.scss";

const PgcPage7 = () => {
  const dispatch = useDispatch();
  const dossierValue = useSelector((state) => state.devis.dossierValue);
  const index = useSelector((state) => state.pgc.index);
  const pgcValue = useSelector((state) => state.pgc.pgcValue);

  const [disableButton, setDisableButton] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [file, setFile] = useState(null);

  const handleDeletePgc = async () => {
    setOpenDialog(false);
    setDisableButton(true);
    try {
      const result = await deletePgc(dossierValue, index, pgcValue);
      if (result.success) {
        dispatch(fetchPgcByDoss(dossierValue))
      }
    } catch (err) {
      console.error("Erreur lors de la suppression du PGC :", err.message);
    } finally {
      setDisableButton(false);
    }
  }

  const handleGenClick = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let blob = await genPgcPDF(pgcValue, dossierValue, index);
    if (blob) {
      setIsOpen(true);
      setFile(blob);
    }
    setDisableButton(false);
  }, [pgcValue]);

  const handleShowPdf = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPgcFile(dossierValue, index, 'pdf');
    if (response.blob.size > 100) {
      setFile(response.blob);
      setIsOpen(true);
    }
    setDisableButton(false);
  }, [pgcValue]);

  const handleGetPdfFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPgcFile(dossierValue, index, 'pdf');
    if (response.blob.type === 'application/pdf') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [pgcValue]);

  const handleGetWordFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPgcFile(dossierValue, index, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);
      dispatch(changePdfFileName(response.fileName))
    }
    setDisableButton(false);
  }, [pgcValue]);

  const handleChangeTitleName = useCallback(() => {
    dispatch(changeTitleName(`PGC`));
  }, [pgcValue]);

  return (
    <>
      <div className="pgc-page7">
        <Header />
        <DocMenu
          file={file}
          getSourceFile={handleGetWordFile}
          getPDF={handleGetPdfFile}
          handleChangeTitleName={handleChangeTitleName}
          updateIndication={() => dispatch(changeIndication(index))}
        />
        <h1 className="title">Plan Général de Coordination (Validation)</h1>
        <NumDossPGC />
        <div className="container">
        </div>
        <div className="buttons-container">
          <Button
            color="primary"
            variant="contained"
            startIcon={<PdfIcon />}
            onClick={handleGenClick}
            disabled={disableButton || !pgcValue}
          >
            Générer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<VisibilityIcon />}
            onClick={() => handleShowPdf()}
            disabled={disableButton || !pgcValue}
          >
            Afficher
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={() => setOpenDialog(true)}
            style={{ backgroundColor: (disableButton || !pgcValue) ? "" : "red" }}
            disabled={disableButton || !pgcValue}
          >
            Supprimer
          </Button>
          {disableButton && (
            <CircularProgress className="spinner" color="inherit" />
          )}
        </div>
        <GenPdf
          file={file}
          isOpen={isOpen}
          closeDoc={() => setIsOpen(false)}
          scale={1}
        />
      </div>
      <YesNoDialog
        isOpen={openDialog}
        title={'SUPPRESSION PGC'}
        question={`Êtes-vous sûr de vouloir supprimer le PGC du dossier ${dossierValue} indice "${index}" ?`}
        handleYesClick={() => handleDeletePgc()}
        handleClose={() => setOpenDialog(false)}
      />
    </>
  );
};

export default PgcPage7;